import { makeStyles } from '@material-ui/core/styles';

const FiltersDetailsUseStyles = makeStyles(theme => ({
  FiltersDetails: {
    '&__table': {
      position: 'absolute',
      bottom: 60,
      left: '50%',
      transform: 'translateX(-50%)',
      minWidth: 380,
      minHeight: 100,
      backgroundColor: 'rgba(0, 0 , 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 5,
      padding: 15,
      opacity: 1,
      transition: 'opacity 0.5s',
      '&__details': {
        color: theme.palette.white,
        fontWeight: 500,
        padding: 10,
        width: '100%',
        '&__scroll': {
          padding: '5px 0',
          height: '100%',
          maxHeight: 250,
          margin: '5px 0',
          overflowY: 'auto',
        },
        '&__container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          '&__button': {
            margin: '5px !important',
            width: 150,
            height: 50,
            '&--big': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
            },
          },
        },
      },
    },
  },
}));

export { FiltersDetailsUseStyles };
